module.exports = __webpack_public_path__ + "static/media/pie_chart.b75f7d1e.png";